import Alert from './Alert'
export type { AlertProps } from './Alert'
export default Alert
